/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OutBop,
    OutBopFromJSON,
    OutBopFromJSONTyped,
    OutBopToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConfigBop
 */
export interface ConfigBop {
    /**
     * 
     * @type {Array<OutBop>}
     * @memberof ConfigBop
     */
    bops: Array<OutBop>;
    /**
     * 
     * @type {string}
     * @memberof ConfigBop
     */
    resultCode: string;
}

export function ConfigBopFromJSON(json: any): ConfigBop {
    return ConfigBopFromJSONTyped(json, false);
}

export function ConfigBopFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigBop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bops': ((json['bops'] as Array<any>).map(OutBopFromJSON)),
        'resultCode': json['resultCode'],
    };
}

export function ConfigBopToJSON(value?: ConfigBop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bops': ((value.bops as Array<any>).map(OutBopToJSON)),
        'resultCode': value.resultCode,
    };
}


